import React, {Fragment, useState} from "react";
import {Col, Form, Input, Row} from "antd";
import {FormattedMessage} from "react-intl";
import {VideoFile} from "@models/video-file";
import {Image} from "@models/image";
import VideoFilesSelection from "@components/video-files/Selection";
import WidgetItemImageSelection from "@components/widgets/widgetItemForms/WidgetItemImageSelection";
import {SelectionMode} from "@models";

interface TeaserVideoProps {
  form: any;
  selectedVideoFile: VideoFile | null;
  selectedPoster: Image | null;
}

const WidgetItemTeaserVideoSelection: React.FC<TeaserVideoProps> = props => {
  const {form, selectedVideoFile, selectedPoster} = props;
  const [videoFile, setVideoFile] = useState(selectedVideoFile || null);

  const onSelectVideoFile = (selected: VideoFile) => {
    setVideoFile(selected);
    form.setFieldsValue({
      video_file: selected,
      video_file_id: selected.id,
      video_file_title: selected.title,
    });
  };

  return (
    <Fragment>
      <Form.Item className={"no-label"}>
        {form.getFieldDecorator("video_file", {
          initialValue: videoFile
        })(<Input type={`hidden`}/>)}
      </Form.Item>
      <Form.Item className={"no-label"}>
        {form.getFieldDecorator("video_file_title", {
          initialValue: videoFile ? videoFile.title : ""
        })(<Input type={`hidden`}/>)}
      </Form.Item>
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item label={<FormattedMessage id="app.video_file" defaultMessage="Video File"/>}>
            {form.getFieldDecorator("video_file_id", {
              initialValue: videoFile ? videoFile.id : null,
              rules: [
                {
                  required: true,
                  message: (
                    <FormattedMessage
                      id="app.file_is_required"
                      defaultMessage="Video File"
                    />
                  )
                }
              ]
            })(<Input type={`hidden`}/>)}
            <VideoFilesSelection
              mode={SelectionMode.DEFAULT}
              onChange={onSelectVideoFile as any}
              initialValue={videoFile}
            />
          </Form.Item>
        </Col>
      </Row>
      <WidgetItemImageSelection
        form={form}
        label="app.select_poster_image"
        field="poster_file"
        selectedImage={selectedPoster}
        required={false}
      />
    </Fragment>
  );
};

export default WidgetItemTeaserVideoSelection;
